import React from 'react';
import { BRAND_LOGO } from '../data/offer';
type SiteFooterProps = {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
};
export function SiteFooter({
  onOpenPrivacy,
  onOpenTerms
}: SiteFooterProps) {
  const year = new Date().getFullYear();
  return <footer className="border-t border-[#3d312c] bg-[#261e1b]" data-id="element-198" data-mp="3mfg88jjmhj3t">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6" data-id="element-199" data-mp="3hhohhsups317">
        <div className="flex items-center gap-2.5" data-id="element-200" data-mp="3dgl4rf7yqn47">
          <img src={BRAND_LOGO} alt="" className="h-9 w-9 rounded-md object-cover object-top" data-id="element-201" data-mp="3diflsig45v30" />
          <span className="font-display text-lg font-bold text-brand-blush" data-id="element-202" data-mp="38g6v5sqpr542">Mi Cocina Natural</span>
        </div>

        <div className="mt-8 space-y-3 font-sans text-[0.64rem] leading-relaxed text-[#56463f]" data-id="element-203" data-mp="33krgwzosn774">
          <p data-id="element-204" data-mp="2ylon6be9kneg">
            Descargo de Responsabilidad de Salud (Health Disclaimer): «El contenido publicado en
            Mi Cocina Natural tiene fines exclusivamente educativos e informativos y no constituye
            asesoramiento médico, nutricional ni profesional de ningún tipo. La información aquí
            presentada no pretende diagnosticar, tratar, curar ni prevenir ninguna enfermedad o
            condición de salud, y no sustituye la consulta, el diagnóstico ni el tratamiento de un
            profesional de la salud calificado. Si presentas síntomas digestivos persistentes,
            estás embarazada, en período de lactancia, tomas medicación o tienes alguna condición
            médica, consulta siempre con tu médico antes de realizar cambios en tu alimentación,
            rutina de ejercicios o estilo de vida.
          </p>
          <p data-id="element-205" data-mp="1esbh138hudhb">
            Los testimonios y comentarios presentados en este sitio reflejan experiencias
            individuales y se muestran con fines ilustrativos. Los resultados varían de persona a
            persona en función de la genética, el punto de partida, la edad, los hábitos y el nivel
            de compromiso individual. Ninguna información en este sitio constituye una garantía o
            promesa de resultados específicos.»
          </p>
          <p data-id="element-206" data-mp="2h3thxh24zqpp">
            Descargo de Responsabilidad de Plataformas (Social Media Disclaimer): «Este sitio web
            no forma parte del sitio web de Facebook™ o Facebook Inc. Además, este sitio NO está
            respaldado, patrocinado ni administrado de ninguna manera por Facebook™, Meta
            Platforms, Inc., TikTok™ o ByteDance Ltd. FACEBOOK™ y TIKTOK™ son marcas comerciales
            registradas de sus respectivos propietarios. El acceso y uso de este sitio están
            sujetos a nuestras propias políticas de privacidad y términos de servicio, los cuales
            son independientes de las plataformas de redes sociales mencionadas.»
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-[#3d312c] pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-207" data-mp="1pau6v94rsmmm">
          <p className="font-sans text-xs text-[#7a675e]" data-id="element-208" data-mp="1fe7k2esvvlhy">
            © {year} Mi Cocina Natural. Todos los derechos reservados.
          </p>
          <nav aria-label="Legal" className="flex items-center gap-5" data-id="element-209" data-mp="3r1kwzqdfb9l9">
            <button type="button" onClick={onOpenPrivacy} className="font-sans text-xs font-medium text-[#a8948a] underline underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-blush" data-id="element-210" data-mp="3vzun3mkajk00">
              Política de Privacidad
            </button>
            <button type="button" onClick={onOpenTerms} className="font-sans text-xs font-medium text-[#a8948a] underline underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-blush" data-id="element-211" data-mp="38d64eyngjnic">
              Términos de Uso
            </button>
          </nav>
        </div>
      </div>
    </footer>;
}